<template>
  <UIDrawer
    :is-open
    :title
    :z-index
    :allow-tray
    @minimize="handleMinimize"
    @close="handleClose"
  >
    <DocumentForm :instance="modal.entity" @close="handleClose" />
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { DocumentClass } from '..'
import { ModalClass } from '@types'

import {
  DOCUMENT_MODAL_TITLE,
  DOCUMENT_MODAL_TITLE_NEW,
  DOCUMENT_MODAL_TITLE_NEW_FILE,
  DOCUMENT_MODAL_TITLE_FILE,
  DOCUMENT_MODAL_TITLE_NEW_THUMBNAIL,
  DOCUMENT_MODAL_TITLE_THUMBNAIL,
} from './utils/const'

import { UIDrawer } from '@ui/modals'
import DocumentForm from './DocumentForm.vue'

type Props = {
  modal: ModalClass<DocumentClass>
}

const props = defineProps<Props>()

const title = computed(() => {
  if (props.modal.entity.isThumbnail) {
    return props.modal.entity.isNew ? DOCUMENT_MODAL_TITLE_NEW_THUMBNAIL : DOCUMENT_MODAL_TITLE_THUMBNAIL
  }
  if (props.modal.entity.isFile) {
    return props.modal.entity.isNew ? DOCUMENT_MODAL_TITLE_NEW_FILE : DOCUMENT_MODAL_TITLE_FILE
  }
  return props.modal.entity.isNew ? DOCUMENT_MODAL_TITLE_NEW : DOCUMENT_MODAL_TITLE
})

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)
const allowTray = computed(() => props.modal.allowTray)

const handleMinimize = () => {
  props.modal.hide()
}

const handleClose = () => {
  props.modal.conditionalClose()
}
</script>
